import TEMPLATES from "@/constants/templates";

export default {
    methods: {
        // Route: https://vetter.test/view/settings/template/{templateType}/{encodedId}
        // Ensures the URL parameter {templateType} matches the expected component template type.
        //
        // If they match, the function allows the component to load. Otherwise, it redirects
        // the user to the template list page. This prevents users from manually
        // changing the URL template type to load an incorrect page.
        validateTemplateType(templateType, componentTemplateType) {
            if (
                templateType &&
                parseInt(templateType) === componentTemplateType
            ) {
                return true;
            }

            this.$router.push({
                name: "template_list",
                params: {
                    type: TEMPLATES.LIST[componentTemplateType].route
                }
            });
        }
    }
};
